<!--
<template>
  <div>
    <b-row class="match-height">
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading2" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="primary"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total}}
              </h3>
              <span>Total</span><br>
              <b-badge variant="primary" class="mt-1 font-small-4 font-weight-bolder">
                {{c_total_d}}
              </b-badge>
            </div>
            <b-avatar
                variant="light-primary"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="UsersIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading2" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="secondary"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total_p}}
              </h3>
              <span>Pendientes</span><br>
              <b-badge variant="secondary" class="mt-1 font-small-4 font-weight-bolder">
                {{c_total_p_d}}
              </b-badge>
            </div>
            <b-avatar
                variant="light-secondary"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="ClockIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading2" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="info"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total_pa}}
              </h3>
              <span>Por Abonar</span><br>
              <b-badge variant="info" class="mt-1 font-small-4 font-weight-bolder">
                {{c_total_pa_d}}
              </b-badge>
            </div>
            <b-avatar
                variant="light-info"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="UserCheckIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading2" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="success"/>
              </h3>
              <h3 v-else  class="mb-25 font-weight-bolder">
                {{c_total_a}}
              </h3>
              <span>Abonados</span><br>
              <b-badge variant="success" class="mt-1 font-small-4 font-weight-bolder">
                {{c_total_a_d}}
              </b-badge>
            </div>
            <b-avatar
                variant="light-success"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="DollarSignIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading2" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="danger"/>
              </h3>
              <h3 v-else  class="mb-25 font-weight-bolder">
                {{c_total_e}}
              </h3>
              <span>Errores</span><br>
              <b-badge variant="danger" class="mt-1 font-small-4 font-weight-bolder">
                {{c_total_e_d}}
              </b-badge>
            </div>
            <b-avatar
                variant="light-danger"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="XIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <b-card no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading2" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="warning"/>
              </h3>
              <h3 v-else  class="mb-25 font-weight-bolder">
                {{c_total_c}}
              </h3>
              <span>N° Celular</span>
            </div>
            <b-avatar
                variant="light-warning"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="PhoneIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-card no-body >
      <b-card-body class="px-1 pt-1 pb-0">

        <b-row>
          <b-col
              xl="2"
              md="3"
              sm="6"
              class="mb-sm-1"
          >
            <b-button
                v-if="$can('read', 'Utilidades')"
                variant="gradient-primary"
                @click="traerTotal"
                :disabled="loading"
                block
                size="sm"
            >
              <span>Recargar&emsp;</span>
              <span v-if="loading"><b-spinner style="width: 16px; height: 16px;" /></span>
              <feather-icon v-else icon="RefreshCwIcon" />
            </b-button>
          </b-col>
          <b-col
              xl="3"
              md="9"
              sm="6"
          >
            <v-select
                id="banco_f"
                v-model="bancoSelected"
                :options="bancos"
                placeholder="Seleccionar banco..."
                @input="filtros2"
                class="select-size-sm"
            />
          </b-col>
          <b-col
              xl="3"
              md="9"
              sm="6"
              class="mb-sm-1"
          >
            <v-select
                id="estado_f"
                v-model="estadoSelected"
                :options="estados"
                :reduce="estados => estados.value"
                label="text"
                key="value"
                placeholder="Seleccionar estado..."
                @input="filtros2"
                class="select-size-sm"
            />
          </b-col>

          <b-col
              xl="4"
              md="3"
              sm="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group>
                <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Buscar"
                    :disabled="loading"
                    @input="filtros2"
                    size="sm"
                />
              </b-input-group>
            </div>
          </b-col>
        </b-row>

      </b-card-body>

      <b-table
          v-if="$can('read', 'Utilidades')"
          hover
          responsive
          class="position-relative"
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="cPaginacion"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tablas."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >

        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>

        <template #cell(fecha_n)="data">
          <span style="white-space: nowrap">{{ data.value }}</span>
        </template>

        <template #cell(estado)="data">
          <b-badge :variant="status[1][parseInt(data.value)]">
            {{ status[0][parseInt(data.value)] }}
          </b-badge>
        </template>

        <template #cell(utilidad_neta)="data">
          <span style="white-space: nowrap">S/ {{data.value}}</span>
        </template>

        <template #cell(fecha_n)="data">
          <span style="white-space: nowrap">{{ data.value }}</span>
        </template>

        <template #cell(acciones)="data">
          <div class="text-nowrap">
            <feather-icon
                v-if="$can('update', 'Utilidades')"
                :id="`btn_${data.item.id}_editar`"
                icon="EditIcon"
                size="16"
                class="mx-1"
                @click="mostrarModal2(2, data.item.id, data.item.estado, data.item.banco, data.item.n_cuenta, data.item.nombres)"
            />
            <b-tooltip
                title="Editar registro"
                :target="`btn_${data.item.id}_editar`"
            />
          </div>
        </template>
      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
          />

        </b-form-group>

        <div>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>

      <b-modal
          v-if="$can(['read', 'update'], 'Utilidades')"
          id="modalRegistro"
          v-model="estadoModal"
          :title="infoModal.title"
          :ok-title="infoModal.boton"
          cancel-variant="outline-secondary"
          cancel-title="Cancelar"
          @ok="okModal"
          centered
      >
        <form
            ref="form"
            @submit.stop.prevent="enviarFormulario"
        >
          <b-row>
            <b-col md="12" class="text-center font-medium-2 m-1">
              <b>
                {{nombres}}
              </b>
            </b-col>
            <b-col md="12">
              <b-form-group
                  label="Estado"
                  label-for="estado"
                  invalid-feedback="Seleccione estado"
              >
                <v-select
                    id="estado"
                    v-model="estado"
                    :options="estados"
                    :reduce="estados => estados.value"
                    label="text"
                    key="value"
                    placeholder="Seleccionar estado..."
                    required
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                  label="Observación"
                  label-for="observacion"
                  invalid-feedback="Observación es requerido"
              >
                <b-form-textarea
                    v-model="observacion"
                    id="observacion"
                    placeholder="Observación"
                    rows="2"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </b-modal>
    </b-card>
  </div>
</template>
-->

<!--
<script>
import axiosIns from '../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
  BFormFile,
  BFormTextarea, BSpinner,BButtonGroup,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BFormFile,
    BFormTextarea, BSpinner, BButtonGroup,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      sortBy: 'id',
      sortDesc: false,
      sortDirection: 'desc',
      filter: null,
      filterOn: ['banco'],
      estadoModal: false,
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'dni',
          label: 'DNI',
          sortable: true
        },
        {
          key: 'fecha_n',
          label: 'Fecha N.',
          sortable: true
        },
        {
          key: 'nombres',
          label: 'Nombres',
          sortable: true
        },
        {
          key: 'banco',
          label: 'Banco',
          sortable: true
        },
        {
          key: 'n_cuenta',
          label: 'N° Cuenta',
          sortable: true
        },
        {
          key: 'utilidad_neta',
          label: 'Utilidad',
          sortable: true
        },
        {
          key: 'celular',
          label: 'Celular',
        },
        {
          key: 'estado',
          label: 'Estado',
          sortable: true
        },
        {
          key: 'acciones'
        },
      ],
      items: [],
      status: [
        {
          0: 'Pendiente',
          1: 'Por abonar',
          2: 'Abonado',
          3: 'Error',
        },
        {
          0: 'light-warning',
          1: 'light-info',
          2: 'light-success',
          3: 'light-danger',
        }
      ],
      validacion: null,
      estados: [
        {value: '0', text: "Pendiente"},
        {value: '1', text: "Por abonar"},
        {value: '2', text: "Abonado"},
        {value: '3', text: "Error"}
      ],
      codigo: '',
      descrip: '',
      nombre: '',
      estado: null,
      estadoFiltro: null,
      id: 0,
      tipo: 0,
      observacion: '',
      banco: '',
      n_cuenta: '',
      nombres: '',
      loading: false,
      loading2: false,

      c_total: 0,
      c_total_p: 0,
      c_total_pa: 0,
      c_total_a: 0,
      c_total_e: 0,
      c_total_c: 0,

      c_total_d: 0,
      c_total_p_d: 0,
      c_total_pa_d: 0,
      c_total_a_d: 0,
      c_total_e_d: 0,
      c_total_c_d: 0,

      bancos: [
        'BANCO DE LA NACION',
        'BBVA',
        'BCP',
        'CAJA PIURA',
        'CAJA SULLANA',
        'CAJA TRUJILLO',
        'INTERBANK',
        'SCOTIABANK',
        'Abrir cuenta BCP'
      ],
      estadoSelected: null,
      bancoSelected: null,

      spd: []
    }
  },
  computed: {
    sortOptions() {
      return this.fields
          .filter(
              invoice =>
                  invoice.estado === '1' &&
                  (invoice.dni.toLowerCase().includes(this.filter.toLowerCase()) || invoice.nombres.toLowerCase().includes(this.filter.toLowerCase())),
          )
    },
  },
  mounted() {
    // this.traerFundos();
    this.traerTotal();
  },
  methods: {

    traerTotal(){
      var yo = this
      yo.loading2 = true
      yo.loading = true

      var config = {
        method: 'get',
        url: '/utilidad/total/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.c_total = 0
              yo.c_total_c = 0
              yo.c_total_d = 0
              for (const valuest of response.data){
                if (valuest.estado === '0'){
                  yo.c_total_p = valuest.total.toLocaleString()
                  yo.c_total_p_d = parseFloat(valuest.suma).toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
                }
                else if (valuest.estado === '1'){
                  yo.c_total_pa = valuest.total.toLocaleString()
                  yo.c_total_pa_d = parseFloat(valuest.suma).toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
                }
                else if (valuest.estado === '2'){
                  yo.c_total_a = valuest.total.toLocaleString()
                  yo.c_total_a_d = parseFloat(valuest.suma).toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
                }
                else if (valuest.estado === '3' || valuest.estado === '4'){
                  yo.c_total_e = valuest.total.toLocaleString()
                  yo.c_total_e_d = parseFloat(valuest.suma).toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
                }

                yo.c_total_c += valuest.celular
                yo.c_total_c_d += parseFloat(valuest.suma)

                yo.c_total += valuest.total
                yo.c_total_d += parseFloat(valuest.suma)
              }

              yo.totalRows = yo.c_total

              yo.c_total_c = yo.c_total_c.toLocaleString()
              yo.c_total_c_d = yo.c_total_c_d.toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})

              yo.c_total = yo.c_total.toLocaleString('pe-PE')
              yo.c_total_d = yo.c_total_d.toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading2 = false
            yo.traerFundos()
          });
    },

    traerFundos(){
      var yo = this
      yo.loading = true
      yo.items = []
      yo.spd = []

      /*
      var spd = parseInt(yo.c_total / 6)
      var ids = 0;

      for(let i = 0; yo.c_total >= spd*(i+1); i++){
        console.log(spd*i + (i === 0 ? 0 : 1) +' - '+spd*(i+1))
        ids = i
      }

      if (spd*(ids+1) < yo.c_total){
        console.log(spd*(ids+1)+(1)+' - '+yo.c_total)
      }
      */

      var config = {
        method: 'get',
        url: '/sedadilitu/todos/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.items = response.data;
              yo.spd = response.data;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
          });
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    mostrarModal(tipo, id, codigo, descrip, nombre, estado){
      this.tipo = tipo
      this.estadoModal = true

      if (this.tipo === 1 ){
        this.infoModal.title = 'Registrar Fundo'
        this.infoModal.boton = 'Registar'
      }
      else if (this.tipo === 2 ){
        this.infoModal.title = 'Editar Empleado'
        this.infoModal.boton = 'Editar'

        this.id = id
        this.codigo = codigo
        this.descrip = descrip
        this.nombre = nombre

        this.estado = estado
      }
    },

    mostrarModal2(tipo, id, estado, banco, n_cuenta, nombres){
      this.tipo = tipo
      this.estadoModal = true

      this.infoModal.title = 'Editar Empleado'
      this.infoModal.boton = 'Editar'

      this.id = id
      this.estado = estado
      this.banco = banco
      this.n_cuenta = n_cuenta
      this.nombres = nombres
    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: 5000
          })
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },

    validarFormulario() {
      const valid = this.$refs.form.checkValidity()
      this.validacion = valid
      return valid
    },

    resetModal() {
      this.codigo = ''
      this.descrip = ''
      this.nombre = ''
      this.estado = ''
      this.validacion = null

      this.nombres = ''

      this.resetInfoModal()
    },

    okModal(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.enviarFormulario()
    },

    enviarFormulario() {
      // Exit when the form isn't valid
      if (!this.validarFormulario()) {
        return
      }

      // Hide the modal manually
      this.$nextTick(() => {
        var yo = this
        const fecha = new Date().toLocaleDateString('pe-PE', {year: 'numeric', month: 'long', day: '2-digit'})

        var data = JSON.stringify({
          "uti_empleado": yo.id,
          "estado": yo.estado,
          "observacion": yo.observacion,
          "fecha_texto": fecha
        });

        var config = {
          method: 'post',
          url: 'sedadilitu/crear/',
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        };

        axiosIns(config)
            .then(function (response) {

              if (response.status === 201){

                var data3 = JSON.stringify({
                  "banco": yo.banco,
                  "n_cuenta": yo.n_cuenta,
                  "estado": yo.estado,
                  "observacion": yo.observacion,
                });

                var config3 = {
                  method: 'put',
                  url: 'utilempleado/editar/'+yo.id,
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  data: data3
                };

                axiosIns(config3)
                    .then(function (response3){

                      if(response3.status === 200){

                        yo.traerFundos()
                        yo.mostrarNotificacion('¡Bien Hecho!', 'BellIcon', "El registró se editó correctamente.", 'success')
                      }

                    })
                    .catch(function (error) {
                      yo.mostrarNotificacion('Error', 'BellIcon', error, 'danger')
                      console.log(error);
                    });

              }else{
                yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
              }

            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
            });

        this.estadoModal = false
      })
    },

    eliminarRegistro(id, fundo){
      var yo = this

      this.$swal({
        title: '¡Alerta!',
        text: "¿Seguro que quieres eliminar el fundo " + fundo + "?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          var config = {
            method: 'delete',
            url: '/fundos/eliminar/' + id,
            headers: { }
          };

          axiosIns(config)
              .then(function (response) {
                if (response.status === 204){
                  yo.traerFundos();
                  yo.mostrarNotificacion('Registro eliminado', 'CheckIcon', 'El fundo ha sido eliminado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
                }
              })
              .catch(function (error) {
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
              });
        }
      })
    },

    filtros(){

      if (this.filter.length > 2){
        this.items = this.spd
        this.items = this.items.filter(invoice => invoice.dni.toLowerCase().includes(this.filter.toLowerCase()) || invoice.dni && invoice.nombres.toLowerCase().includes(this.filter.toLowerCase()))
        this.totalRows = this.items.length
      }
    },

    filtros2(){
      var palabra = this.filter !== null ? this.filter.toLowerCase() : ''
      this.items = this.spd
      this.items = this.items.filter(
          invoice =>
              (invoice.dni.toLowerCase().includes(palabra) || invoice.nombres.toLowerCase().includes(palabra)) &&
              invoice.estado === (this.estadoSelected || invoice.estado) &&
              invoice.banco === (this.bancoSelected || invoice.banco))
      this.totalRows = this.items.length
    }
  },
}
</script>
-->

<!--
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'Seleccionar';
}
</style>
-->


<template>
  <div>
    <b-row class="match-height">
      <!--
      <b-col
          xl="12"
          md="12"
          sm="12"
      >
        <b-card no-body>
          <b-card-body>
            <b-row>
              <b-col md="6">
                <v-select
                    id="estado"
                    v-model="anioSelected"
                    :options="anios"
                    @input="changeAnio"
                    label="text"
                    key="value"
                    placeholder="Seleccionar estado..."
                    required
                />
              </b-col>
              <b-col md="6">

                <b-button
                    id="update"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    block
                    variant="primary"
                    @click="traerTotal"
                    :disabled="loading"
                >
                  <span v-if="loading"> Actualizando..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                  <span v-else>Actualizar</span>

                </b-button>

              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      -->
      <b-col
          class="pr-lg-0 pr-sm-1"
      >
        <b-card class="mb-1" no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="primary"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total}}
              </h3>
              <span>Colaboradores</span><br>
              <b-badge variant="primary" class="mt-1 mb-1 font-small-4 font-weight-bolder">
                {{c_total_d}}
              </b-badge><br>
              <b class="font-medium-1">{{ c_total_por }} %</b><br>
            </div>
            <b-avatar
                variant="light-primary"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="UsersIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          class="pr-lg-0 pr-sm-1"
      >
        <b-card class="mb-1" no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="success"/>
              </h3>
              <h3 v-else  class="mb-25 font-weight-bolder">
                {{c_total_a}}
              </h3>
              <span>Abonados</span><br>
              <b-badge variant="success" class="mt-1 mb-1 font-small-4 font-weight-bolder">
                {{c_total_a_d}}
              </b-badge><br>
              <b class="font-medium-1">{{ c_total_a_por }} %</b><br>
            </div>
            <b-avatar
                variant="light-success"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="DollarSignIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          class="pr-lg-0 pr-sm-1"
      >
        <b-card class="mb-1" no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="info"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total_pa}}
              </h3>
              <span>En Proceso de Abono</span><br>
              <b-badge variant="info" class="mt-1 mb-1 font-small-4 font-weight-bolder">
                {{c_total_pa_d}}
              </b-badge><br>
              <b class="font-medium-1">{{ c_total_pa_por }} %</b><br>
            </div>
            <b-avatar
                variant="light-info"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="UserCheckIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
          class="pr-lg-0 pr-sm-1"
      >
        <b-card class="mb-1" no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="secondary"/>
              </h3>
              <h3 v-else class="mb-25 font-weight-bolder">
                {{c_total_p}}
              </h3>
              <span>Pendientes</span><br>
              <b-badge variant="secondary" class="mt-1 mb-1 font-small-4 font-weight-bolder">
                {{c_total_p_d}}
              </b-badge><br>
              <b class="font-medium-1">{{ c_total_p_por }} %</b><br>
            </div>
            <b-avatar
                variant="light-secondary"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="ClockIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
      >
        <b-card class="mb-1" no-body>
          <b-card-body class="d-flex justify-content-between align-items-center p-1">
            <div class="truncate">
              <h3 v-if="loading" class="mb-25 font-weight-bolder">
                <b-spinner type="grow" label="Loading..." variant="danger"/>
              </h3>
              <h3 v-else  class="mb-25 font-weight-bolder">
                {{c_total_e}}
              </h3>
              <span>Errores</span><br>
              <b-badge variant="danger" class="mt-1 mb-1 font-small-4 font-weight-bolder">
                {{c_total_e_d}}
              </b-badge><br>
              <b class="font-medium-1">{{ c_total_e_por }} %</b><br>
            </div>
            <b-avatar
                variant="light-danger"
                size="45"
            >
              <feather-icon
                  size="21"
                  icon="XIcon"
              />
            </b-avatar>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-card no-body >
      <b-card-body class="px-1 pt-1 pb-0">

        <b-row>
          <b-col
              xl="2"
              md="6"
              sm="6"
              class="pb-1"
          >
            <b-row>
              <b-col xl="4"
                     md="4"
                     sm="4"
                     class="pr-lg-0 pr-sm-1"
              >

                <b-button
                    id="update"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="traerTotal()"
                    :disabled="loading"
                    block
                    size="sm"
                    v-b-tooltip.hover="'Actualizar data'"
                >
                  <span v-if="loading"><b-spinner style="width: 16px; height: 16px;" /></span>
                  <span v-else><feather-icon icon="RefreshCwIcon"/></span>

                </b-button>
              </b-col>
              <b-col xl="8"
                     md="8"
                     sm="8"
              >
                <v-select
                    id="banco_f"
                    v-model="anioSelected"
                    :options="anios"
                    :disabled="loading"
                    placeholder="Seleccionar año..."
                    @input="traerTotal()"
                    :clearable="false"
                    class="select-size-sm"
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col
              xl="3"
              md="6"
              sm="6"
              class="pb-1"
          >
            <b-row>
              <b-col xl="12"
                     md="8"
                     sm="8"
              >
                <v-select
                    id="banco_f"
                    v-model="sociedadSelected"
                    :options="sociedades"
                    :disabled="loading"
                    placeholder="Seleccionar sociedad..."
                    @input="changeAnio()"
                    class="select-size-sm"
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col
              xl="2"
              md="6"
              sm="6"
              class="pb-1"
          >
            <v-select
                id="colaborador"
                v-model="colaboradorSelected"
                :options="colaborador"
                placeholder="Colaborador..."
                @input="changeAnio()"
                :disabled="loading"
                class="select-size-sm"
            />
          </b-col>
          <b-col
              xl="3"
              md="6"
              sm="6"
              class="pb-1"
          >
            <v-select
                id="banco_f"
                v-model="bancoSelected"
                :options="bancos"
                placeholder="Banco..."
                @input="filtros2"
                :disabled="loading"
                class="select-size-sm"
            />
          </b-col>
          <b-col
              xl="2"
              md="6"
              sm="6"
              class="pb-1"
          >
            <v-select
                id="estado_f"
                v-model="estadoSelected"
                :options="estados"
                :reduce="estados => estados.value"
                label="text"
                key="value"
                placeholder="Estado..."
                @input="filtros2"
                :disabled="loading"
                class="select-size-sm"
            />
          </b-col>
          <b-col
              xl="3"
              md="6"
              sm="12"
              class="pb-1"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group>
                <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Buscar"
                    :disabled="loading"
                    @input="filtros2"
                    size="sm"
                />
                <b-input-group-append>
                  <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                      size="sm"
                  >
                    Borrar
                  </b-button>
                </b-input-group-append>


              </b-input-group>
            </div>
          </b-col>
        </b-row>

      </b-card-body>

      <b-table
          v-if="$can('read', 'Utilidades')"
          responsive
          hover
          small
          class="position-relative"
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="cPaginacion"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tablas."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <template #cell(fecha_n)="data">
          {{ data.value }} @ {{ data.value.split('-')[2] }}/{{ data.value.split('-')[1] }}/{{ data.value.split('-')[0] }}
        </template>



        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>

        <template #cell(estado)="data">
          <b-badge :variant="status[1][parseInt(data.value)]">
            {{ status[0][parseInt(data.value)] }}
          </b-badge>
        </template>

        <template #cell(utilidad_neta)="data">
            <span style="white-space: nowrap">
              {{ parseFloat(data.value).toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) }}
            </span>
        </template>

        <template #cell(fecha_n)="data">
          <span class="text-nowrap">
            {{
              new Date(data.value.split('-')).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
        </template>

        <template #cell(acciones)="data">
          <div class="text-nowrap">
            <feather-icon
                v-if="$can('update', 'Utilidades')"
                :id="`btn_${data.item.id}_editar`"
                icon="EditIcon"
                class="mr-1"
                @click="mostrarModal2(2, data.item.id, data.item.estado, data.item.banco, data.item.n_cuenta, data.item.nombres)"
            />

            <feather-icon
                :id="`btn_${data.item.id}_view`"
                icon="EyeIcon"
                @click="mostrarModalPDF(data.item)"
            />
          </div>
        </template>

        <template #cell(fecha_hora)="data">
          <span class="text-nowrap" v-if="data.value === null || data.value === '' || data.value === ' '">
            --
          </span>
          <span class="text-nowrap" v-else>
            {{
              new Date(data.value).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                localeMatcher: 'best fit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
        </template>
      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

        <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
          />

        </b-form-group>

        <!--
        <div>
          <b>Total de registros: {{ this.items.length }}</b>
        </div>
        -->

        <div>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>

      <b-modal
          v-if="$can(['read', 'update'], 'Utilidades')"
          id="modalRegistro"
          v-model="estadoModal"
          :title="infoModal.title"
          :ok-title="infoModal.boton"
          cancel-variant="outline-secondary"
          cancel-title="Cancelar"
          @ok="okModal"
          centered
      >
        <form
            ref="form"
            @submit.stop.prevent="enviarFormulario"
        >
          <b-row class="px-1">
            <b-col md="12" class="text-center font-medium-2 m-1">
              <b>
              {{nombres}}
              </b>
            </b-col>
            <b-col md="12">
              <b-form-group
                  label="Estado"
                  label-for="estado"
                  invalid-feedback="Seleccione estado"
              >
                <v-select
                    id="estado"
                    v-model="estado"
                    :options="estados"
                    :reduce="estados => estados.value"
                    label="text"
                    key="value"
                    placeholder="Seleccionar estado..."
                    required
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                  label="Observación"
                  label-for="observacion"
                  invalid-feedback="Observación es requerido"
              >
                <b-form-textarea
                    v-model="observacion"
                    id="observacion"
                    placeholder="Observación"
                    rows="2"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </b-modal>

      <b-modal
          v-if="$can(['read', 'update'], 'Utilidades')"
          id="modalRegistro"
          v-model="estadoModalPDF"
          title="Documento PDF"
          size="lg"
          hide-footer
          hide-header
      >
        <template>
          <iframe v-if="!loadingpdf" :src="pdfUrl" width="100%" style="height: 86vh"></iframe>
          <div v-else>
            <div class="text-center">
              <p>&emsp;</p>
              <b-spinner style="width: 35px; height: 35px;" />
              <p>&emsp;</p>
              <p v-if="">Generando documento ...</p>
            </div>
          </div>
        </template>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import axiosIns from '../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import pdf from 'vue-pdf'

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
  BFormFile,
  BFormTextarea, BSpinner,BButtonGroup,
  VBTooltip,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BFormFile,
    BFormTextarea, BSpinner, BButtonGroup
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      sortBy: 'id',
      sortDesc: false,
      sortDirection: 'desc',
      filter: null,
      filterOn: ['banco'],
      estadoModal: false,
      estadoModalPDF: false,
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'acciones',
          label: '#',
          thClass: 'text-center font-small-2',
          tdClass: 'text-center font-small-3',
        },
        {
          key: 'id',
          label: 'Id',
          sortable: true,
          thClass: 'text-center font-small-2',
          tdClass: 'text-center font-small-3',
        },
        {
          key: 'estado',
          label: 'Estado',
          sortable: true,
          thClass: 'text-center font-small-2',
          tdClass: 'text-center font-small-3',
        },
        {
          key: 'fecha_hora',
          label: 'fecha registro',
          sortable: true,
          thClass: 'text-center font-small-2',
          tdClass: 'font-small-3',
        },
        {
          key: 'sociedad',
          label: 'Sociedad',
          sortable: true,
          thClass: 'text-center font-small-2',
          tdClass: 'font-small-3',
          formatter: (value) => {
            const sociedadesMap = {
              PE10: "AGROVISION",
              PE20: "ARENA VERDE",
            };
            return sociedadesMap[value] || value; // Si no encuentra el código, deja el valor original
          }
        },
        {
          key: 'estado_empleado',
          label: 'Empleado',
          sortable: true,
          thClass: 'text-center font-small-2',
          tdClass: 'text-center font-small-3',
        },
        {
          key: 'dni',
          label: 'DNI',
          sortable: true,
          thClass: 'text-center font-small-2',
          tdClass: 'text-right font-small-3',
        },
        {
          key: 'fecha_n',
          label: 'Fecha N.',
          sortable: true,
          thClass: 'text-center font-small-2',
          tdClass: 'text-center font-small-3',
        },
        {
          key: 'nombres',
          label: 'Nombres',
          sortable: true,
          thClass: 'text-center font-small-2',
          tdClass: 'font-small-3',
        },
        {
          key: 'banco',
          label: 'Banco',
          sortable: true,
          thClass: 'text-center font-small-2',
          tdClass: 'font-small-3',
        },
        {
          key: 'n_cuenta',
          label: 'N° Cuenta',
          sortable: true,
          thClass: 'text-center font-small-2',
          tdClass: 'font-small-3',
        },
        {
          key: 'utilidad_neta',
          label: 'Utilidad',
          sortable: true,
          thClass: 'text-center font-small-2',
          tdClass: 'text-right font-small-3',
        },
        {
          key: 'celular',
          label: 'Celular',
          thClass: 'text-center font-small-2',
          tdClass: 'text-right font-small-3',
        },
      ],
      items: [],
      status: [
        {
          0: 'Pendiente',
          1: 'En proceso de abono',
          2: 'Abonado',
          3: 'Error',
        },
        {
          0: 'light-warning',
          1: 'light-info',
          2: 'light-success',
          3: 'light-danger',
        }
      ],
      validacion: null,
      resumen: [],
      estados: [
        {value: '0', text: "Pendiente"},
        {value: '1', text: "En proceso de abono"},
        {value: '2', text: "Abonado"},
        {value: '3', text: "Error"}
      ],
      anios: [2021, 2022],
      sociedades: [
        { label: "AGROVISION", value: "PE10" },
        { label: "ARENA VERDE", value: "PE20" }
      ],
      anioSelected: 0,
      sociedadSelected: null,
      colaborador: ['ACTIVO', 'CESADO'],
      colaboradorSelected: null,
      codigo: '',
      descrip: '',
      nombre: '',
      estado: null,
      estadoFiltro: null,
      id: 0,
      tipo: 0,
      observacion: '',
      banco: '',
      n_cuenta: '',
      nombres: '',
      loading: false,
      loading2: false,
      loadingpdf: false,

      c_total: 0,
      c_total_p: 0,
      c_total_pa: 0,
      c_total_a: 0,
      c_total_e: 0,

      c_total_d: 0,
      c_total_p_d: 0,
      c_total_pa_d: 0,
      c_total_a_d: 0,
      c_total_e_d: 0,

      c_total_por: 0,
      c_total_p_por: 0,
      c_total_pa_por: 0,
      c_total_a_por: 0,
      c_total_e_por: 0,

      bancos: [
        'BANCO DE LA NACION',
        'BBVA',
        'BCP',
        'CAJA PIURA',
        'CAJA SULLANA',
        'CAJA TRUJILLO',
        'INTERBANK',
        'SCOTIABANK',
        'Abrir cuenta BCP'
      ],
      estadoSelected: null,
      bancoSelected: null,

      spd: [],

      pdfUrl: null,
    }
  },
  mounted() {
    // this.traerFundos();
    this.traerTotal();
  },
  methods: {

    traerTotal(){
      const yo = this
      yo.loading = true
      yo.colaboradorSelected = null

      yo.totalRows = 1
      yo.c_total = 0
      yo.c_total_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_p = 0
      yo.c_total_p_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_pa = 0
      yo.c_total_pa_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_a = 0
      yo.c_total_a_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_e = 0
      yo.c_total_e_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})

      yo.c_total_por = 0
      yo.c_total_p_por = 0
      yo.c_total_pa_por = 0
      yo.c_total_a_por = 0
      yo.c_total_e_por = 0

      const data = JSON.stringify(
          {
            "anio": yo.anioSelected
          })

      const config = {
        method: 'post',
        url: '/utilidades/sedadilitu/resumen/',
        headers: {
          'Content-Type': 'application/json'
        },
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){

              yo.anioSelected = null
              yo.anios = response.data['anios']

              if(response.data['data'].length > 0){
                yo.anioSelected = response.data['data'][0].anio
                yo.items = response.data['data'];
                yo.spd = response.data['data'];
                yo.resumen = response.data['resumen'];
                yo.totalRows = yo.items.length
              }

              const agrupado = response.data['resumen'].reduce((result, item) => {
                const estado = item.estado;
                result[estado] = result[estado] || { total_cantidad: 0, total_uti: 0 };
                result[estado].total_cantidad += item.total_cantidad;
                result[estado].total_uti += item.total_uti;

                result.total_cantidad += item.total_cantidad;
                result.total_uti += item.total_uti;
                return result;
              }, {total_cantidad: 0, total_uti: 0});


              yo.c_total = agrupado['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0})
              yo.c_total_d = agrupado['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
              yo.c_total_p = '0' in agrupado ? agrupado['0']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_p;
              yo.c_total_p_d = '0' in agrupado ? agrupado['0']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_p_d;
              yo.c_total_pa = '1' in agrupado ? agrupado['1']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_pa;
              yo.c_total_pa_d = '1' in agrupado ? agrupado['1']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_pa_d;
              yo.c_total_a = '2' in agrupado ? agrupado['2']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_a;
              yo.c_total_a_d = '2' in agrupado ? agrupado['2']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_a_d;
              yo.c_total_e = '3' in agrupado ? agrupado['3']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_e;
              yo.c_total_e_d = '3' in agrupado ? agrupado['3']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_e_d;


              yo.c_total_por = (isNaN(agrupado['total_uti'] / agrupado['total_uti']) ? 0 : agrupado['total_uti'] / agrupado['total_uti'] * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
              yo.c_total_a_por = '2' in agrupado ? (isNaN(parseInt(agrupado['2']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['2']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_a_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_a_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
              yo.c_total_p_por = '0' in agrupado ? (isNaN(parseInt(agrupado['0']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['0']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_p_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_p_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
              yo.c_total_pa_por = '1' in agrupado ? (isNaN(parseInt(agrupado['1']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['1']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_pa_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_pa_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
              yo.c_total_e_por = '3' in agrupado ? (isNaN(parseInt(agrupado['3']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['3']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_e_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_e_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})

            }
          })
          .catch(function (error) {
            yo.loading = false
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
            yo.filtros2()
          });
    },

    traerFundos(){
      const yo = this
      yo.loading = true
      yo.items = []
      yo.spd = []

      /*
      var spd = parseInt(yo.c_total / 6)
      var ids = 0;

      for(let i = 0; yo.c_total >= spd*(i+1); i++){
        console.log(spd*i + (i === 0 ? 0 : 1) +' - '+spd*(i+1))
        ids = i
      }

      if (spd*(ids+1) < yo.c_total){
        console.log(spd*(ids+1)+(1)+' - '+yo.c_total)
      }
      */

      const config = {
        method: 'get',
        url: '/utilidades/sedadilitu/todos/'
      }

      axiosIns(config)
      .then(function (response) {
        if(response.status === 200){
          yo.items = response.data;
          yo.spd = response.data;

        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function (){
        yo.loading = false
        yo.filtros2()
      });
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    mostrarModal(tipo, id, codigo, descrip, nombre, estado){
      this.tipo = tipo
      this.estadoModal = true

      if (this.tipo === 1 ){
        this.infoModal.title = 'Registrar Fundo'
        this.infoModal.boton = 'Registar'
      }
      else if (this.tipo === 2 ){
        this.infoModal.title = 'Editar Empleado'
        this.infoModal.boton = 'Editar'

        this.id = id
        this.codigo = codigo
        this.descrip = descrip
        this.nombre = nombre

        this.estado = estado
      }
    },

    mostrarModal2(tipo, id, estado, banco, n_cuenta, nombres){
      this.tipo = tipo
      this.estadoModal = true

      this.infoModal.title = 'Editar Empleado'
      this.infoModal.boton = 'Editar'

      this.id = id
      this.estado = estado
      this.banco = banco
      this.n_cuenta = n_cuenta
      this.nombres = nombres
    },

    mostrarModalPDF(datoUser){
      const yo = this
      yo.estadoModalPDF = true
      yo.loadingpdf = true
      yo.pdfUrl = null

      const datas = JSON.stringify({
        'dni': datoUser.dni,
        'fecha_n': datoUser.fecha_n,
        'anio': parseInt(datoUser.anio.toString()),
        'sociedad':datoUser.sociedad
      })

      const config = {
        method: 'post',
        url: '/utilidades/archivo/pdf/',
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'arraybuffer',
        data: datas
      }

      axiosIns(config)
          .then(function (response) {

            if(response.status === 200){

              yo.pdfUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))

            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error en la creación del archivo',
                    icon: 'XIcon',
                    text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                    variant: 'danger',
                  },
                },
                {
                  timeout: 3000,
                  position: 'top-center',
                })
          })
          .finally(function () {
            yo.loadingpdf = false
          });
    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
        component: ToastificationContent,
        props:{
          title: titulo,
          icon: icono,
          text: texto,
          variant: variante
        }
      },
      {
        timeout: 5000,
        position: 'top-center',
      })
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },

    validarFormulario() {
      const valid = this.$refs.form.checkValidity()
      this.validacion = valid
      return valid
    },

    resetModal() {
      this.codigo = ''
      this.descrip = ''
      this.nombre = ''
      this.estado = ''
      this.validacion = null

      this.nombres = ''

      this.resetInfoModal()
    },

    okModal(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.enviarFormulario()
    },

    enviarFormulario() {
      // Exit when the form isn't valid
      if (!this.validarFormulario()) {
        return
      }

      // Hide the modal manually
      this.$nextTick(() => {
        const yo = this
        const fecha = new Date().toLocaleDateString('pe-PE', {year: 'numeric', month: 'long', day: '2-digit'})

        const data = JSON.stringify({
          'uti_empleado': yo.id,
          'estado': yo.estado,
          'observacion': yo.observacion,
          'fecha_texto': fecha
        })

        const config = {
          method: 'post',
          url: 'utilidades/sedadilitu/crear/',
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        }

        axiosIns(config)
            .then(function (response) {

              if (response.status === 201){

                const data3 = JSON.stringify({
                  'banco': yo.banco,
                  'n_cuenta': yo.n_cuenta,
                  'estado': yo.estado,
                  'observacion': yo.observacion,
                })

                const config3 = {
                  method: 'put',
                  url: 'utilidades/utilempleado/editar/' + yo.id,
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  data: data3
                }

                axiosIns(config3)
                    .then(function (response3){

                      if(response3.status === 200){

                        yo.traerFundos()
                        yo.mostrarNotificacion('¡Bien Hecho!', 'BellIcon', "El registró se editó correctamente.", 'success')
                      }

                    })
                    .catch(function (error) {
                      yo.mostrarNotificacion('Error', 'BellIcon', error, 'danger')
                      console.log(error);
                    });

              }else{
                yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
              }

            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
            });

        this.estadoModal = false
      })
    },

    eliminarRegistro(id, fundo){
      const yo = this

      this.$swal({
        title: '¡Alerta!',
        text: "¿Seguro que quieres eliminar el fundo " + fundo + "?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const config = {
            method: 'delete',
            url: '/configuracion/fundos/eliminar/' + id,
            headers: {}
          }

          axiosIns(config)
              .then(function (response) {
              if (response.status === 204){
                  yo.traerFundos();
                  yo.mostrarNotificacion('Registro eliminado', 'CheckIcon', 'El fundo ha sido eliminado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
                }
              })
              .catch(function (error) {
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
              });
        }
      })
    },

    filtros(){

      if (this.filter.length > 2){
        this.items = this.spd
        this.items = this.items.filter(invoice => invoice.dni.toLowerCase().includes(this.filter.toLowerCase()) || invoice.dni && invoice.nombres.toLowerCase().includes(this.filter.toLowerCase()))
        this.totalRows = this.items.length
      }
    },

    filtros2(){
      const palabra = this.filter !== null ? this.filter.toLowerCase() : ''
      this.items = this.spd
      this.items = this.items.filter(
          invoice =>
              (invoice.dni.toLowerCase().includes(palabra) || invoice.nombres.toLowerCase().includes(palabra)) &&
              invoice.estado === (this.estadoSelected || invoice.estado) &&
              invoice.banco === (this.bancoSelected || invoice.banco) &&
              invoice.estado_empleado === (this.colaboradorSelected || invoice.estado_empleado) &&
              invoice.sociedad === ((this.sociedadSelected && this.sociedadSelected.value) || invoice.sociedad)
      )
      this.totalRows = this.items.length
    },

    changeAnio() {
      const yo = this

      yo.c_total_por = 0
      yo.c_total_p_por = 0
      yo.c_total_pa_por = 0
      yo.c_total_a_por = 0
      yo.c_total_e_por = 0

      yo.c_total = 0
      yo.c_total_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_p = 0
      yo.c_total_p_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_pa = 0
      yo.c_total_pa_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_a = 0
      yo.c_total_a_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_e = 0
      yo.c_total_e_d = parseFloat('0').toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})

      const agrupado = yo.resumen.reduce((result, item) => {
        const estado = item.estado;
        // Filtrar por colaborador seleccionado (estado_empleado)
        if (yo.colaboradorSelected !== null){
          if (item.estado_empleado === yo.colaboradorSelected) {
            // Filtrar por sociedad seleccionada
            if (yo.sociedadSelected === null || item.sociedad === yo.sociedadSelected.value) {
            result[estado] = result[estado] || { total_cantidad: 0, total_uti: 0 };
            result[estado].total_cantidad += item.total_cantidad;
            result[estado].total_uti += item.total_uti;

            result.total_cantidad += item.total_cantidad;
            result.total_uti += item.total_uti;
            }
          }
        }else{
          // Si no hay colaborador seleccionado
          if (yo.sociedadSelected === null || item.sociedad === yo.sociedadSelected.value) {
          result[estado] = result[estado] || { total_cantidad: 0, total_uti: 0 };
          result[estado].total_cantidad += item.total_cantidad;
          result[estado].total_uti += item.total_uti;

          result.total_cantidad += item.total_cantidad;
          result.total_uti += item.total_uti;
          }
        }

        return result;
      }, {total_cantidad: 0, total_uti: 0});


      yo.c_total = agrupado['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0})
      yo.c_total_d = agrupado['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'})
      yo.c_total_p = '0' in agrupado ? agrupado['0']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_p;
      yo.c_total_p_d = '0' in agrupado ? agrupado['0']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_p_d;
      yo.c_total_pa = '1' in agrupado ? agrupado['1']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_pa;
      yo.c_total_pa_d = '1' in agrupado ? agrupado['1']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_pa_d;
      yo.c_total_a = '2' in agrupado ? agrupado['2']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_a;
      yo.c_total_a_d = '2' in agrupado ? agrupado['2']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_a_d;
      yo.c_total_e = '3' in agrupado ? agrupado['3']['total_cantidad'].toLocaleString('pe-PE', {minimumFractionDigits: 0}) : yo.c_total_e;
      yo.c_total_e_d = '3' in agrupado ? agrupado['3']['total_uti'].toLocaleString('es-PE', {style: 'currency', currency: 'PEN'}) : yo.c_total_e_d;

      yo.c_total_por = (isNaN(agrupado['total_uti'] / agrupado['total_uti']) ? 0 : agrupado['total_uti'] / agrupado['total_uti'] * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
      yo.c_total_a_por = '2' in agrupado ? (isNaN(parseInt(agrupado['2']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['2']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_a_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_a_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
      yo.c_total_p_por = '0' in agrupado ? (isNaN(parseInt(agrupado['0']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['0']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_p_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_p_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
      yo.c_total_pa_por = '1' in agrupado ? (isNaN(parseInt(agrupado['1']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['1']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_pa_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_pa_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})
      yo.c_total_e_por = '3' in agrupado ? (isNaN(parseInt(agrupado['3']['total_uti']) / parseInt(agrupado['total_uti'])) ? 0 : parseInt(agrupado['3']['total_uti']) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2}) : (isNaN(parseInt( yo.c_total_e_d) / parseInt(agrupado['total_uti'])) ? 0 : parseInt( yo.c_total_e_d) / parseInt(agrupado['total_uti']) * 100).toLocaleString('pe-PE', {maximumFractionDigits: 2})


      yo.filtros2();

    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'Seleccionar';
}
.modal-body{
  padding: 0!important;
}
</style>

